import { render, staticRenderFns } from "./MyExperts.vue?vue&type=template&id=6794f00c&"
import script from "./MyExperts.vue?vue&type=script&lang=js&"
export * from "./MyExperts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports